// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetLectureLessonHistoryPagedListRequestModel from '../../model/get-lecture-lesson-history-paged-list-request-model';
import GetLectureLessonHistoryPagedListRequestDTO from '../dto/get-lecture-lesson-history-paged-list-request-dto';
import dtoSchema from '../schemas/get-lecture-lesson-history-paged-list-request-schema';

export default abstract class GetLectureLessonHistoryPagedListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetLectureLessonHistoryPagedListRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.lectureLessonId = data.lectureLessonId;
      this.lecturerId = data.lecturerId;
      this.from = data.from;
      this.to = data.to;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int64}
  */
  lectureLessonId?: number;
  /**
  * @type {int64}
  */
  lecturerId?: number;
  /**
  * @type {date-time}
  */
  from?: string;
  /**
  * @type {date-time}
  */
  to?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetLectureLessonHistoryPagedListRequestDTO>): GetLectureLessonHistoryPagedListRequestModel;
  static toModel(dto: DeepPartial<GetLectureLessonHistoryPagedListRequestDTO> | undefined | null): GetLectureLessonHistoryPagedListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetLectureLessonHistoryPagedListRequestDTO> | undefined | null): GetLectureLessonHistoryPagedListRequestModel | undefined {
    return dto ? new GetLectureLessonHistoryPagedListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetLectureLessonHistoryPagedListRequestModel> | GetLectureLessonHistoryPagedListRequestModel): GetLectureLessonHistoryPagedListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      lectureLessonId: unwrapped.lectureLessonId,
      lecturerId: unwrapped.lecturerId,
      from: unwrapped.from,
      to: unwrapped.to,
      searchCriteria: unwrapped.searchCriteria,
    } as GetLectureLessonHistoryPagedListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetLectureLessonHistoryPagedListRequestModel, can not map to GetLectureLessonHistoryPagedListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
